import api from "services/api";

export const fetchUserLoginHistories = async (params = {}) => {
  try {
    const queryParams = new URLSearchParams();

    if (params.fromDate) queryParams.append("fromDate", params.fromDate);
    if (params.toDate) queryParams.append("toDate", params.toDate);
    if (params.userId) queryParams.append("userId", params.userId);
    if (params.ipAddress) queryParams.append("ipAddress", params.ipAddress);
    if (params.browser) queryParams.append("browser", params.browser);
    if (params.page) queryParams.append("page", params.page);
    if (params.pageSize) queryParams.append("pageSize", params.pageSize);
    if (params.sortBy) queryParams.append("sortBy", params.sortBy);
    if (params.sortDirection)
      queryParams.append("sortDirection", params.sortDirection);

    const response = await api.get(
      `/userloginhistory?${queryParams.toString()}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching user login histories:", error);
    throw error;
  }
};

export const fetchUserLoginHistoryById = async (id) => {
  try {
    const response = await api.get(`/userloginhistory/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching user login history:", error);
    throw error;
  }
};

export const createUserLoginHistory = async (loginData) => {
  try {


    const response = await api.post("/userloginhistory", loginData);


    return response.data;
  } catch (error) {
    console.error("Error creating user login history:", error);
    console.error("Error details:", error.response?.data);
    throw error;
  }
};

export const updateLogoutTime = async (loginHistoryId, logoutData) => {
  try {
    const response = await api.put(
      `/userloginhistory/${loginHistoryId}/logout`,
      logoutData
    );
    return response.data;
  } catch (error) {
    console.error("Error updating logout time:", error);
    throw error;
  }
};

// Export service object for compatibility
export const userLoginHistoryService = {
  getUserLoginHistory: fetchUserLoginHistories,
  getUserLoginHistoryById: fetchUserLoginHistoryById,
  createUserLoginHistory: createUserLoginHistory,
  updateLogoutTime: updateLogoutTime,
};
